// router/iicc.js

import IiccMain from '@/pages/iicc/iicc-main/IiccMain.vue'
import Iicc from '@/pages/iicc/iicc-page/Iicc.vue'
import SurveyResult from '@/pages/iicc/selfassessment/survey/SurveyResult.vue'
import SurveyFreeResult from '@/pages/iicc/selfassessment/survey/SurveyFreeResult.vue'

export default [
  // 기존 별도 페이지 유지
  { path: '/iicc', name: 'iicc', component: Iicc },
  { path: '/surveyresult', name: 'surveyresult', component: SurveyResult },
  { path: '/surveyfreeresult', name: 'surveyfreeresult', component: SurveyFreeResult },

  // 메인 진입
  {
    path: '/iiccmain',
    name: 'iiccmain',
    component: IiccMain,
  },

  // 기존 URL 호환용 redirect
  {
    path: '/iiccmain/iicc',
    redirect: '/iiccmain?tab=iicc',
  },
  {
    path: '/iiccmain/certification',
    redirect: '/iiccmain?tab=certification',
  },
  {
    path: '/iiccmain/selfassessment/surveypublic',
    redirect: '/iiccmain?tab=selfassessment&subTab=surveypublic',
  },
  {
    path: '/iiccmain/selfassessment/externalauditor',
    redirect: '/iiccmain?tab=selfassessment&subTab=externalauditor',
  },
  {
    path: '/iiccmain/selfassessment/surveyauditcommittee',
    redirect: '/iiccmain?tab=selfassessment&subTab=surveyauditcommittee',
  },
  {
    path: '/iiccmain/selfassessment/surveyboard',
    redirect: '/iiccmain?tab=selfassessment&subTab=surveyboard',
  },
  {
    path: '/iiccmain/selfassessment/surveyinternalauditor',
    redirect: '/iiccmain?tab=selfassessment&subTab=surveyinternalauditor',
  },
  {
    path: '/iiccmain/selfassessment/surveyexecutive',
    redirect: '/iiccmain?tab=selfassessment&subTab=surveyexecutive',
  },
]